import * as store from '@/_store';
const STORE = store.store.getters;

function isReferrerGood() {
  function strEndsWith(str, suffix) {
    var reguex = new RegExp(suffix + '$');
    if (str.match(reguex) != null) return true;
    return false;
  }

  var i;
  var domain;
  var dx = 'cloud.daimi';
  var goodDomains = [
    'localhost',
    '192.168.1.202',
    '192.168.1.6',
    '192.168.1.111',
    'app.daimi.vn',
    'daimi.vn',
    dx + '.vn'
  ];

  var ref = location.hostname;
  for (i = 0; i < goodDomains.length; i++) {
    domain = goodDomains[i];

    if (ref.includes('192.168.10.')) {
      return true;
    } else if (strEndsWith(ref, domain)) {
      return true;
    }
  }
  return false;
}

const stringToPath = function(path) {
  if (typeof path !== 'string') return path;
  let path_without_ext = path
    .split('.')
    .slice(0, -1)
    .join('.')
    .toLowerCase()
    .replace('./', '');
  let spath = '';
  path_without_ext.split('/').forEach((name, index) => {
    if (name != 'index' && name.length > 0) {
      if (index == 0) {
        spath += name;
      } else {
        spath += '/' + name;
      }
    }
  });
  return spath;
};

let routes = [];
const pages = require.context('@/pages/', true, /[\w-]+\.vue$/);
pages.keys().forEach(pathName => {
  // eslint-disable-next-line no-useless-escape
  let fileName = pathName.replace(/^.*[\\\/]/, '');
  if (!pathName.toLowerCase().includes('component') && !fileName.startsWith('__')) {
    const page = pages(pathName);
    if (page.default.name) {
      let path = page.default.path;
      if (!path) {
        path = stringToPath(pathName);
      }
      let route = {
        path: path,
        name: page.default.name,
        meta: page.default.meta,
        component: () => import(`@/pages/${pathName.replace('./', '')}`)
      };
      routes.push(route);
      // console.log(
      //   `import route: ${route.name}  -  @/pages/${pathName.replace(
      //     "./",
      //     ""
      //   )} -:- ${route.path}`
      // );
    }
  }
});

routes.push({
  path: '/index.html',
  redirect: '/'
});

import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

import { createRouterLayout } from 'vue-router-layout';
const RouterLayout = createRouterLayout(layout => {
  return import(`@/layouts/${layout}.layout`);
});

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  var title = to.meta.title;
  if (title) {
    document.title = to.meta.title + ' | ERP ĐAI MI';
  } else {
    document.title = 'ERP ĐAI MI';
  }

  if (!to.matched.length) {
    next('/notFound');
  } else {
    next();
  }

  if (!to.matched.some(record => record.meta.danger)) {
    if (!isReferrerGood()) {
      next({
        path: '/danger'
      });
    }
  } else if (to.matched.some(record => record.meta.auth)) {
    if (STORE.token) {
      next();
    } else {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});
export default router;
